import moment from 'moment';
import sha256 from 'js-sha256';
import { has } from 'lodash';

const cacheObjects = {};

class FetchingCache {

  constructor(requestOptions, cacheOptions) {
    this.requestOptions = requestOptions;
    this.cacheOptions = cacheOptions;
    this.paramsHash = this.stringifyParams();
    this.shouldStore = true;
  }

  stringifyParams() {
    return sha256(JSON.stringify(this.requestOptions.params || ''));
  }

  ensureObjects() {
    const { entities, endpoint } = this.requestOptions;

    if (!has(cacheObjects, entities)) {
      cacheObjects[entities] = {};
    }

    if (!has(cacheObjects, `${entities}.${endpoint}`)) {
      cacheObjects[entities][endpoint] = {};
    }
  }

  cacheExists() {
    const { entities, endpoint } = this.requestOptions;
    const { method = null } = this.cacheOptions;

    if (method && method === 'localStorage') {
      return localStorage.getItem(`${entities}.${endpoint}.${this.paramsHash}`) !== null;
    }

    return has(cacheObjects, `${entities}.${endpoint}.${this.paramsHash}`);
  }

  fetchTime() {
    const { entities, endpoint } = this.requestOptions;
    const { method = null } = this.cacheOptions;

    if (method && method === 'localStorage') {
      const item = JSON.parse(localStorage.getItem(`${entities}.${endpoint}.${this.paramsHash}`));
      return moment(item.time);
    }

    return cacheObjects[entities][endpoint][this.paramsHash].time;
  }

  isValid() {
    const { invalidateAfter } = this.cacheOptions;

    if (this.cacheExists()) {
      return this.fetchTime().clone().add(invalidateAfter, 's').isAfter(moment());
    }

    return false;
  }

  retrieve() {
    const { entities, endpoint } = this.requestOptions;
    const { method = null } = this.cacheOptions;

    return new Promise((resolve) => {
      this.shouldStore = false;

      if (method && method === 'localStorage') {
        const item = JSON.parse(localStorage.getItem(`${entities}.${endpoint}.${this.paramsHash}`));

        // eslint-disable-next-line no-console
        if (process.env.NODE_ENV !== 'production') console.log('Retrieving from localStorage', item.data);

        resolve(item.data);
      }

      // eslint-disable-next-line no-console
      if (process.env.NODE_ENV !== 'production') console.log('Retrieving from memory cache', cacheObjects[entities][endpoint][this.paramsHash].data, cacheObjects);
      resolve(cacheObjects[entities][endpoint][this.paramsHash].data);
    });
  }

  store(data) {
    if (!this.shouldStore) return;

    const { entities, endpoint, params } = this.requestOptions;
    const { method = null } = this.cacheOptions;
    const cacheObject = {
      time: moment(),
      params,
      data,
    };

    if (method && method === 'localStorage') {
      // eslint-disable-next-line no-console
      if (process.env.NODE_ENV !== 'production') console.log('Storing to localStorage', data);

      localStorage.setItem(`${entities}.${endpoint}.${this.paramsHash}`, JSON.stringify(cacheObject));
    } else {
      this.ensureObjects();

      // eslint-disable-next-line no-console
      if (process.env.NODE_ENV !== 'production') console.log('Storing to memory cache', data, cacheObjects);

      cacheObjects[entities][endpoint][this.paramsHash] = cacheObject;
    }
  }

}

export default FetchingCache;



// WEBPACK FOOTER //
// ./src/services/FetchingCache.js